import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Building2, ArrowRight } from 'lucide-react';

/** Legacy /register — fleet signup is now via gov-approved company application. */
const Register: React.FC = () => (
  <Navigate to="/register-company" replace />
);

export const RegisterLegacyNotice: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center p-8 bg-white">
    <div className="max-w-md text-center">
      <Building2 className="w-12 h-12 text-electric-500 mx-auto mb-4" />
      <h1 className="text-2xl font-bold text-slate-800 mb-2">Registrera ditt taxiföretag</h1>
      <p className="text-slate-500 text-sm mb-6">
        Konton skapas när Transportstyrelsen har godkänt din ansökan. Förare läggs till av företagets administratör — inte genom öppen registrering.
      </p>
      <Link to="/register-company" className="btn-primary inline-flex">
        Ansök om åtkomst
        <ArrowRight className="w-4 h-4" />
      </Link>
      <p className="mt-6 text-sm text-slate-500">
        Redan godkänd? <Link to="/login" className="text-electric-600 font-semibold">Logga in</Link>
      </p>
    </div>
  </div>
);

export default Register;
